// extracted by mini-css-extract-plugin
export default {"input":"input_input__DHaJY typography_text--sm__BgKHZ"};